import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-counter-component',
    templateUrl: './counter.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CounterComponent {
  public currentCount = 0;

  public incrementCounter() {
    this.currentCount++;
  }
}
